(function($) {

  //
  //  ScrollTo Menu
  //

  function calculateNextOrEnd(index) {
    let $currentAnchor = $('#ScrollContent .custom-anchor').eq(index);
    let $nextAnchor = $('#ScrollContent .custom-anchor').eq(index + 1);

    if ($nextAnchor.length) {
      let offsetDifference = Math.floor($nextAnchor.offset().top - $currentAnchor.offset().top);
      return `+=${offsetDifference}px bottom`;
    } else {
      return "bottom top";
    }
  }

  let $scrollToMenu = $('#ScrollToMenu');
  if( $scrollToMenu.length ) {

    var $ul = $scrollToMenu.find('ul');

    $('#ScrollContent .custom-anchor').each((i, el) => {
      var $this = $(el);
      var label = $this.attr('data-label');
      var id = $this.attr('id');

      var $element = $('<li><span>'+label+'</span></li>');
      $element.on('click', function(e) {
        gsap.to(window, {
          duration: 1, 
          scrollTo: { 
            y: '#' + id, 
            offsetY: 100 
          }
        });
      });
      $ul.append($element);

      gsap.to($this, {
        scrollTrigger: {
          trigger: $this,
          start: "top bottom",
          end: () => calculateNextOrEnd(i), // Use a function to ensure recalculation
          invalidateOnRefresh: true,
          onEnter: () => $element.addClass('in-viewport'),
          onLeave: () => $element.removeClass('in-viewport'),
          onEnterBack: () => $element.addClass('in-viewport'),
          onLeaveBack: () => $element.removeClass('in-viewport'),
        }
      });
    });

    $scrollToMenu.addClass('is-loaded');
  }

  //
  //  Pin the menu (use #ScrollContent as Endtrigger)
  //

  const scrollToMenu = document.querySelector("#ScrollToMenu");
  if( scrollToMenu ) {

      function calculateStickyEnd() {
        const scrollToMenu = document.querySelector("#ScrollToMenu");
        if( scrollToMenu ) {
          const scrollToMenuBottom = scrollToMenu.offsetHeight;
          return 'bottom top+=' + scrollToMenuBottom + "px";
        }
      }

      gsap.to("#ScrollToMenu", {
        scrollTrigger: {
          trigger: "#ScrollToMenu",
          start: "top top+=100", // When the top of #ScrollToMenu hits the top of the viewport
          endTrigger: "#ScrollContent",
          end: calculateStickyEnd, //"bottom bottom", // When the bottom of #ScrollContent hits the bottom of the viewport
          pin: true,
          pinSpacing: true,
          markers: false,
          invalidateOnRefresh: true
        }
      });
  }

  //
  // Refresh ScrollTrigger on content changes
  //

  function refreshScrollTrigger() {
    ScrollTrigger.getAll().forEach(trigger => trigger.refresh()); // Refresh all ScrollTriggers
  }

  const scrollContent = document.querySelector('#ScrollContent');
  if( scrollContent ) {
    const observer = new MutationObserver(refreshScrollTrigger);
    observer.observe(scrollContent, { childList: true, subtree: true });
  }

  //
  //  ScrollTo Button
  //
  $('.button.scroll-to').on('click', function(e) {
    e.preventDefault();
    let id = $(this).attr('href'); 
    if( id ) {
      let $element = $(id);
      if( $element.length ) {
        gsap.to(window, {
          duration: 1, 
          scrollTo: id
        });
      }
    }
  });

})(jQuery);
